import React from "react";
import PendingHoldsTable from "./PendingHoldsTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const PendingHoldsIndex = () => (
  <ReportProgramsPage
    TableComponent={PendingHoldsTable}
    loadingMessage="Loading pending holds report..."
  />
);

export default PendingHoldsIndex;
